import { TableCell, TableRow } from "@material-ui/core"
import moment from "moment";


export const ItemContacto = ({row,handleClick,index,isSelected}) =>{
    const isItemSelected = isSelected(row.apellido_y_nombre);
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <TableRow
            hover
            onClick={(event) => handleClick(event, row.name)}
            role="checkbox"
            aria-checked={isItemSelected}
            tabIndex={-1}
            key={row.name}
            selected={isItemSelected}
        >
            <TableCell>
            </TableCell>
            <TableCell component="th" id={labelId} scope="row" padding="none">{moment(row.fecha).isValid()?moment(row.fecha).format('DD/MM/YYYY'):'-'}</TableCell>
            <TableCell align="right">{row.usuario}</TableCell>
            <TableCell align="right">{row.direccionIP}</TableCell>
            <TableCell align="right">{row.nombreAfiliado}</TableCell>
            <TableCell align="right">{row.cuil}</TableCell>
        </TableRow>
)
}